export default __webpack_public_path__ + "static/media/1557.98d77991.png";